import React from 'react';
import { Typography, TypographyVariant } from 'components/Typography';
import type { types as AuthTypes } from 'modules/Auth';
import Button from 'components/Button';
import { replaceItemsInString } from 'lib/formatters/replaceItemsInString';
import useCountdown from 'hooks/useCountdown';
import { MINUTE } from '../../../../constants';
import { resendCodeButtonData } from './data';
import './resendCodeButton.css';

export interface ResendCodeButtonProps {
  contactMethod: AuthTypes.MultiFactorAuthMethodType;
  contactInfo: string;
  initialCountdown?: number;
  onClick: () => void;
}

export const ResendCodeButton = ({
  contactMethod,
  contactInfo,
  initialCountdown = 0,
  onClick
}: ResendCodeButtonProps) => {
  const [countdown, setCountdown] = useCountdown(initialCountdown);

  const handleClick = () => {
    onClick();
    setCountdown(MINUTE);
  };

  return countdown > 0 ? (
    <Typography variant={TypographyVariant.ButtonSm}>
      <span className="resendCodeButton__timeout">
        {replaceItemsInString(resendCodeButtonData.text.timeout, {
          contactInfo,
          countdown: (countdown / 1000).toString()
        })}
      </span>
    </Typography>
  ) : (
    <Button
      className="button--fakeLink"
      type="button"
      onClick={handleClick}
      name={`Resend code to ${contactMethod}`}
    >
      <Typography variant={TypographyVariant.ButtonSm}>
        <span>{replaceItemsInString(resendCodeButtonData.text.default, { contactInfo })}</span>
      </Typography>
    </Button>
  );
};
